import { React, useState, useEffect } from 'react';
import '../master.css';
import { toast } from 'react-toastify';
import ApiService from '../../../../services/apiService';
import userManagement from '../../../../services/userManagement';
import { ClipLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';

const TerminalMaster = () => {
  const [kitchen, setKitchen] = useState([]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    GetTerminal();
  }, []);
  const [formData, setFormData] = useState({
    name: '',
    id: '',
  });
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const CreateKitchen = async () => {
    const userId = await userManagement.getUserId();
    setLoading(true);
    try {
      if (!formData?.name) toast.error('Please Enter Terminal Name');
      else if (!formData?.id) toast.error('Please Enter Terminal Id');
      else {
        let body = {
          terminalId: formData?.id,
          name: formData?.name,
          status: 1,
        };
        const apiService = new ApiService();
        let res = await apiService.post('CREATE_TERMINAL', body);
        if (res?.data?.statusCode == 201) {
          toast?.success('Terminal Created Successfully');
          setFormData({
            name: '',
            id: '',
          });
          GetTerminal();
          setLoading(false);
        } else {
          toast.error(res?.data?.message);
        }
      }
    } catch (error) {
      console.error('Error fetching  data:', error);
      setLoading(false);
    }
    setLoading(false);
  };
  const GetTerminal = async () => {
    try {
      const apiService = new ApiService();
      let res = await apiService.get('GET_TERMINAL');
      setKitchen(res.data.result);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleSwitchChange = async (payment, newActiveStatus) => {
    try {
      await handleUpdatePayment(payment, newActiveStatus);
    } catch (error) {
      console.error('Error updating terminal status:', error);
    }
  };
  const handleUpdatePayment = async (payment, newActiveStatus) => {
    try {
      const apiService = new ApiService();
      debugger;
      const catData = {
        id: payment?.id,
        terminalId: payment?.terminalId,
        name: payment?.name,
        status: newActiveStatus === false ? 0 : 1,
      };
      const res = await apiService.put(`UPDATE_TERMINAL`, catData);
      if (res?.data?.statusCode === 201) {
        toast.success(`${payment?.name} updated successfully!`);
        GetTerminal();
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.error('Error updating Terminal:', error);
    }
  };
  return (
    <div className="p-5 container">
      <div className="catlist p-4">
        <div className="row d-flex">
          <div className="col-lg-4">
            <label htmlFor="validationCustom01" className="form-label">
              {t('terminal')} {t('Id')} *
            </label>
            <input type="text" className="form-control" id="validationCustom01" name="id" value={formData.id} onChange={handleInputChange} required />
          </div>
          <div className="col-lg-4">
            <label htmlFor="validationCustom01" className="form-label">
              {t('terminal')} {t('name')} *
            </label>
            <input type="text" className="form-control" id="validationCustom01" name="name" value={formData.name} onChange={handleInputChange} required />
          </div>
          <div className="col-3 mt-4 center">
            {loading ? (
              <div className="addItem-btn w-75 center">
                <ClipLoader loading={loading} size={30} color="#fff" />
              </div>
            ) : (
              <button className="addItem-btn w-75" onClick={() => CreateKitchen()}>
                {t('save')}
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="catlist mt-5 table-responsive">
        <table className="table table-striped mt-3">
          <thead>
            <tr>
              <th>
                {t('terminal')} {t('Id')}
              </th>
              <th>
                {t('terminal')} {t('name')}
              </th>
              <th>{t('action')}</th>
            </tr>
          </thead>
          <tbody>
            {kitchen?.map((val) => (
              <tr key={val.id}>
                <td>{val.terminalId}</td>
                <td>{val.name}</td>
                <td>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={val.status === 1}
                      onChange={(e) => handleSwitchChange(val, e.target.checked)}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TerminalMaster;
